// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"ds-z","giftOrPromoSelector":"es-z","disabled":"fs-z","subTitle":"gs-z","selectShipAddressMessage":"hs-z","changePayment":"is-z"};